import { Injectable } from '@nestjs/common';
import { UserService } from '../user/user.service';
import { JwtService } from '@nestjs/jwt';
import { JwtPayload } from './jwt.payload';
import { updateUserDto, UserDto } from '../user/dto/user.dto';
import { CreateUserDto, LoginUserDto } from '../user/dto/user.dto';
import { RegistrationStatus } from '../user/dto/registraton.dto';
import { UserRequest } from '../user/dto/user.request';
import { UserResponseModel } from '@analytics-soa/shared-models';
import { UserToDivisionEntity } from '../user/user-to-division.entity';
import { UserEntity } from '../user/user.entity';
@Injectable()
export class AuthService {
  constructor(
    //  @InjectRepository(UserEntity)
    private readonly userService: UserService,
    private readonly jwtService: JwtService,
    // private readonly userRepo: Repository<UserEntity> 
  ) { }

  async validateUser(payload: JwtPayload): Promise<UserDto> {
    const user = await this.userService.findByPayload(payload);
    if (!user) {
      throw 'new HttpException(Invalid token, HttpStatus.UNAUTHORIZED)';
    }
    return user;
  }

  findUser(employeeId: number) {
    return this.userService.findOne({ employeeId });
  }

  async register(userDto: CreateUserDto): Promise<RegistrationStatus> {
    let status: RegistrationStatus = {
      success: true,
      message: 'user registered',
    };
    try {
      // console.log(userDto);
      const userData = await this.userService.create(userDto);
      const userDivision = userDto.divisionId.map((div) => {
        const userDivisionMap = new UserToDivisionEntity()
        userDivisionMap.createdUser = userDto.createdUser;
        userDivisionMap.divisionId = div;
        const user = new UserEntity();
        user.id = userData.id;
        userDivisionMap.userId = user;
        return userDivisionMap;

      });
      await this.userService.saveUserToDivisionMap(userDivision);
      return status
    } catch (err) {
      status = {
        success: false,
        message: err,
      };
    }
    return status;
  }
  // async updateUser(userDto: updateUserDto): Promise<RegistrationStatus> {
  //   let status: RegistrationStatus = {
  //       success: true,   
  //       message: 'user updated',
  //   };
  //   try {
  //     await this.userService.update(userDto);
  //   } catch (err) {
  //       status = {
  //           success: false,        
  //           message: err,
  //       };    
  //   }
  //   return status;  
  // }
  async login(loginUserDto: LoginUserDto): Promise<any> {
    // find user in db    
    try {
      const user = await this.userService.findByLogin(loginUserDto);
      console.log(user);
      // generate and sign token    
      const token = this._createToken(user);

      return {
        // username:user.username,
        status: true,
        user_data: user, ...token,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  private _createToken({ username }: UserDto): any {
    const user: JwtPayload = { username };
    const accessToken = this.jwtService.sign(user);
    console.log(accessToken);
    return {
      expiresIn: '1h',//process.env.EXPIRESIN,
      accessToken,
    };
  }
  async getAllUsers(): Promise<any> {
    const users = await this.userService.getAllUsers();
    return users;
  }

  async updateUser(userDto: updateUserDto): Promise<RegistrationStatus> {
    console.log(userDto);
    let status: RegistrationStatus = {
      success: true,
      message: 'user updated',
    };
    try {
      await this.userService.update(userDto);
    } catch (err) {
      status = {
        success: false,
        message: err,
      };
      console.log(err);
    }
    return status;
  }
  async activateOrDeactivateUser(userReq: UserRequest): Promise<UserResponseModel> {
    //   console.log(State.stateCode);
    const users = await this.userService.activateOrDeactivateUser(userReq);
    return users;
  }
  // async getActiveUsersCount():Promise<UserStatusWiseResponseModel>{
  //   const users=await this.userService.getActiveUsersCount();
  //   return users;
  // }

  async getAllActiveUser(): Promise<any> {
    const users = await this.userService.getAllActiveUser();
    return users;
  }

  async deleteUser(userDto: updateUserDto): Promise<RegistrationStatus> {
    console.log(userDto);
    let status: RegistrationStatus = {
      success: true,
      message: 'user deleted',
    };
    try {
      await this.userService.deleteOne(userDto);
    } catch (err) {
      status = {
        success: false,
        message: err,
      };
      console.log(err);
    }
    return status;
  }
}
